import type { ReactNode } from "react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@components/ui/sheet";

export function IntegrationSetupSheet({ open, title, description, onOpenChange, children }: {
  open: boolean;
  title: string;
  description: string;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
}) {
  return <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="right" className="h-full w-full overflow-y-auto [&>button]:h-11 [&>button]:w-11 sm:max-w-xl">
      <SheetHeader className="pr-10">
        <SheetTitle className="text-xl">{title}</SheetTitle>
        <SheetDescription className="leading-6">{description}</SheetDescription>
      </SheetHeader>
      <div className="mt-6">{children}</div>
    </SheetContent>
  </Sheet>;
}
